module.exports = __webpack_public_path__ + "static/media/page-05.13517660.png";